/**
 * 날짜/시간을 한국어 형식으로 포맷합니다.
 * 예: "2026. 03. 22. 오후 03:30"
 */
export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * 날짜/시간을 초 단위까지 포맷합니다.
 * 예: "2026. 03. 22. 오후 03:30:45"
 */
export function formatDateTime(dateStr: string): string {
  return new Date(dateStr).toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}
